"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : NODATA : STYLES --------------- ++++++++++ */


var _default = {
  nodataview: {
    background: _index.theme.color.light.light.swatch,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& .copy': {
      textAlign: 'center',
      fontSize: (0, _index.pxToEm)(14),
      opacity: '1 !important',
      '& .title': {
        color: _index.theme.color.primary.medium.swatch,
        margin: (0, _index.pxToEm)(16)
      }
    }
  }
};
exports.default = _default;